$(document).ready(function () {
     $(".valentine-variant-select").on("change", function () {
      let selectedVariantId = this.value;
      let productContainer = this.closest(".valentine-product-card");

      // Find the selected <option> inside this dropdown
      let selectedOption = this.querySelector(`option[value="${selectedVariantId}"]`);
      if (!selectedOption) return;

      // Extract price from the option text (assuming "Title - $price")
      let priceText = selectedOption.textContent.split(" - ").pop();

      // Update the "valentine3-current-price" element
      let priceElement = productContainer.querySelector(".valentine-current-price");
      if (priceElement) {
        priceElement.textContent = priceText;
      }

      // Update the hidden variant ID input in the form
      let hiddenInput = productContainer.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = selectedVariantId;
      }
    });
  
  
  
  // Helper function to determine products per slide
    function getProductsPerSlide() {
        return window.innerWidth >= 992 ? 4 : 2;
    }

    // Initialize sliders for each collection tab
    $('.valentine-tab-content').each(function () {
        const $sliderContainer = $(this);
        const $slider = $sliderContainer.find('.valentine-product-slider');
        const $prevButton = $sliderContainer.find('.valentine-prev');
        const $nextButton = $sliderContainer.find('.valentine-next');
        const $dotsContainer = $sliderContainer.find('.valentine-dots');
        const $cards = $slider.find('.valentine-product-card');
        const totalProducts = $cards.length;

        let productsPerSlide = getProductsPerSlide();
        let totalSlides = Math.ceil(totalProducts / productsPerSlide);
        let currentIndex = 0;
        let isAnimating = false;

        // Build dot indicators
        function buildDots() {
            $dotsContainer.empty();
            for (let i = 0; i < totalSlides; i++) {
                $dotsContainer.append('<span class="valentine-dot"></span>');
            }
        }

        // Update active dot
        function updateDots() {
            $dotsContainer.find('.valentine-dot').removeClass('active')
                .eq(currentIndex).addClass('active');
        }

        // Recalculate on resize
        function recalcSlides() {
            productsPerSlide = getProductsPerSlide();
            totalSlides = Math.ceil(totalProducts / productsPerSlide);
            currentIndex = 0;
            buildDots();
            updateDots();
            scrollToSlide(0);
        }

        // Scroll to specific slide
        function scrollToSlide(index) {
            if (isAnimating || index < 0 || index >= totalSlides) return;
            
            isAnimating = true;
            const cardWidth = $cards.first().outerWidth(true);
            const gap = parseInt(getComputedStyle($slider[0]).gap) || 20;
            const scrollAmount = (cardWidth + gap) * productsPerSlide * index;
            
            $slider.animate({ scrollLeft: scrollAmount }, {
                duration: 400,
                complete: () => {
                    currentIndex = index;
                    updateDots();
                    isAnimating = false;
                }
            });
        }

        // Navigation controls
        $nextButton.on('click', () => {
            if (currentIndex < totalSlides - 1) scrollToSlide(currentIndex + 1);
        });

        $prevButton.on('click', () => {
            if (currentIndex > 0) scrollToSlide(currentIndex - 1);
        });

        // Dot navigation
        $dotsContainer.on('click', '.valentine-dot', function () {
            scrollToSlide($(this).index());
        });

        // Handle manual scroll
        let scrollTimeout;
        $slider.on('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const scrollLeft = $slider.scrollLeft();
                const cardWidth = $cards.first().outerWidth(true);
                const gap = parseInt(getComputedStyle($slider[0]).gap) || 20;
                const scrollAmount = (cardWidth + gap) * productsPerSlide;
                
                currentIndex = Math.round(scrollLeft / scrollAmount);
                updateDots();
            }, 100);
        });

        // Initial setup
        buildDots();
        updateDots();


        // Window resize handler
        $(window).on('resize', () => {
            const newProductsPerSlide = getProductsPerSlide();
            if (newProductsPerSlide !== productsPerSlide) recalcSlides();
        });
    });


    function generateRandomRating() {
        return (Math.random() * (4.9 - 4.1) + 4.1).toFixed(1);
    }

    // Set random rating and stars
    // $('.valentine-product-rating').each(function () {
    //     const rating = generateRandomRating();
    //     const starsContainer = $(this).find('.valentine-stars');
    //     const ratingText = $(this).find('.valentine-rating-text');

    //     ratingText.text(`(${rating})`);

    //     const fullStars = Math.floor(rating);
    //     const halfStar = (rating % 1) >= 0.5 ? 1 : 0;
    //     const emptyStars = 5 - fullStars - halfStar;

    //     for (let i = 0; i < fullStars; i++) {
    //         starsContainer.append('<span class="valentine-star full"></span>');
    //     }

    //     if (halfStar) {
    //         starsContainer.append('<span class="valentine-star half"></span>');
    //     }

    //     for (let i = 0; i < emptyStars; i++) {
    //         starsContainer.append('<span class="valentine-star empty"></span>');
    //     }
    // });

    $('.valentine-tab-button').click(function () {
        const index = $(this).index();
        $('.valentine-tab-content').hide();
        $('.valentine-tab-content').eq(index).show();
        $('.valentine-tab-button').removeClass('valentine-active');
        $(this).addClass('valentine-active');
    });

    $('.valentine-tab-button').eq(0).addClass('valentine-active');
    $('.valentine-tab-content').eq(0).show();
});







$(document).ready(function () {
     $(".valentine2-variant-select").on("change", function () {
      let selectedVariantId = this.value;
      let productContainer = this.closest(".valentine2-product-card");

      // Find the selected <option> inside this dropdown
      let selectedOption = this.querySelector(`option[value="${selectedVariantId}"]`);
      if (!selectedOption) return;

      // Extract price from the option text (assuming "Title - $price")
      let priceText = selectedOption.textContent.split(" - ").pop();

      // Update the "valentine3-current-price" element
      let priceElement = productContainer.querySelector(".valentine2-current-price");
      if (priceElement) {
        priceElement.textContent = priceText;
      }

      // Update the hidden variant ID input in the form
      let hiddenInput = productContainer.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = selectedVariantId;
      }
    });
  
  // Helper function to determine products per slide
    function getProductsPerSlide() {
        return window.innerWidth >= 992 ? 4 : 2;
    }

    // Initialize sliders for each collection tab
    $('.valentine2-tab-content').each(function () {
        const $sliderContainer = $(this);
        const $slider = $sliderContainer.find('.valentine2-product-slider');
        const $prevButton = $sliderContainer.find('.valentine2-prev');
        const $nextButton = $sliderContainer.find('.valentine2-next');
        const $dotsContainer = $sliderContainer.find('.valentine2-dots');
        const $cards = $slider.find('.valentine2-product-card');
        const totalProducts = $cards.length;

        let productsPerSlide = getProductsPerSlide();
        let totalSlides = Math.ceil(totalProducts / productsPerSlide);
        let currentIndex = 0;
        let isAnimating = false;

        // Build dot indicators
        function buildDots() {
            $dotsContainer.empty();
            for (let i = 0; i < totalSlides; i++) {
                $dotsContainer.append('<span class="valentine2-dot"></span>');
            }
        }

        // Update active dot
        function updateDots() {
            $dotsContainer.find('.valentine2-dot').removeClass('active')
                .eq(currentIndex).addClass('active');
        }

        // Recalculate on resize
        function recalcSlides() {
            productsPerSlide = getProductsPerSlide();
            totalSlides = Math.ceil(totalProducts / productsPerSlide);
            currentIndex = 0;
            buildDots();
            updateDots();
            scrollToSlide(0);
        }

        // Scroll to specific slide
        function scrollToSlide(index) {
            if (isAnimating || index < 0 || index >= totalSlides) return;
            
            isAnimating = true;
            const cardWidth = $cards.first().outerWidth(true);
            const gap = parseInt(getComputedStyle($slider[0]).gap) || 20;
            const scrollAmount = (cardWidth + gap) * productsPerSlide * index;
            
            $slider.animate({ scrollLeft: scrollAmount }, {
                duration: 400,
                complete: () => {
                    currentIndex = index;
                    updateDots();
                    isAnimating = false;
                }
            });
        }

        // Navigation controls
        $nextButton.on('click', () => {
            if (currentIndex < totalSlides - 1) scrollToSlide(currentIndex + 1);
        });

        $prevButton.on('click', () => {
            if (currentIndex > 0) scrollToSlide(currentIndex - 1);
        });

        // Dot navigation
        $dotsContainer.on('click', '.valentine2-dot', function () {
            scrollToSlide($(this).index());
        });

        // Handle manual scroll
        let scrollTimeout;
        $slider.on('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const scrollLeft = $slider.scrollLeft();
                const cardWidth = $cards.first().outerWidth(true);
                const gap = parseInt(getComputedStyle($slider[0]).gap) || 20;
                const scrollAmount = (cardWidth + gap) * productsPerSlide;
                
                currentIndex = Math.round(scrollLeft / scrollAmount);
                updateDots();
            }, 100);
        });

        // Initial setup
        buildDots();
        updateDots();


        // Window resize handler
        $(window).on('resize', () => {
            const newProductsPerSlide = getProductsPerSlide();
            if (newProductsPerSlide !== productsPerSlide) recalcSlides();
        });
    });


    // function generateRandomRating() {
    //     return (Math.random() * (4.9 - 4.1) + 4.1).toFixed(1);
    // }

    // // Set random rating and stars
    // $('.valentine2-product-rating').each(function () {
    //     const rating = generateRandomRating();
    //     const starsContainer = $(this).find('.valentine2-stars');
    //     const ratingText = $(this).find('.valentine2-rating-text');

    //     ratingText.text(`(${rating})`);

    //     const fullStars = Math.floor(rating);
    //     const halfStar = (rating % 1) >= 0.5 ? 1 : 0;
    //     const emptyStars = 5 - fullStars - halfStar;

    //     for (let i = 0; i < fullStars; i++) {
    //         starsContainer.append('<span class="valentine2-star full"></span>');
    //     }

    //     if (halfStar) {
    //         starsContainer.append('<span class="valentine2-star half"></span>');
    //     }

    //     for (let i = 0; i < emptyStars; i++) {
    //         starsContainer.append('<span class="valentine2-star empty"></span>');
    //     }
    // });

    $('.valentine2-tab-button').click(function () {
        const index = $(this).index();
        $('.valentine2-tab-content').hide();
        $('.valentine2-tab-content').eq(index).show();
        $('.valentine2-tab-button').removeClass('valentine2-active');
        $(this).addClass('valentine2-active');
    });

    $('.valentine2-tab-button').eq(0).addClass('valentine2-active');
    $('.valentine2-tab-content').eq(0).show();
});